import gql from "graphql-tag";

export const DELETE_DEAL_AND_DEAL_ITEMS_BY_ID = gql`
mutation deleteDealAndDealItemsById($id:uuid!){
  delete_Deals(where:{id:{_eq:$id}}){
    returning{id}
  }
  delete_DealItems(where:{dealId:{_eq:$id}}){
    returning{id}
  }
}`

export const DELETE_DEAL_AND_DEAL_ITEMS_BY_CONDITION = gql`
mutation deleteDealAndDealItemsByCondition($condition_deals: Deals_bool_exp!, $condition_dealItems: DealItems_bool_exp!){
  delete_DealItems(where: $condition_dealItems){
    returning{id}
  }
  delete_Deals(where: $condition_deals){
    returning{id}
  } 
}`
